import React, { useEffect } from "react"
import { graphql } from "gatsby"
import { useSelector, useDispatch } from "react-redux"

import * as s from "./ProductCategory.module.scss"

import mapTranslationsToObject from "@utils/mapTranslationsToObject"
import { useSiteTranslations } from "@hooks/useSiteTranslations"
import { ShopHeader } from "../../components/main/shop-header/ShopHeader"
import { ProductsList } from "../../components/main/products-list/ProductsList"
import { NoChristmasProductsList } from "../../components/main/no-christmas-products-list/NoChristmasProductsList"
import { PaymentBanner } from "../../components/main/payment-banner/PaymentBanner"
import { FilterBar } from "../../components/main/filter-bar/FilterBar"
import Layout from "../../components/main/layout/Layout"
import { SEO } from "../../components/common/seo/SEO"
import { setState } from "../../ducks/filterProductsSlice"

const ProductCategory = props => {
  const { pageContext, data } = props
  const { category, categoryProducts } = pageContext
  const {
    shopTranslations: { shop },
  } = useSiteTranslations()
  const dispatch = useDispatch()
  let isChristmas = category.handle === "christmas"
  const categoryTranslations =
    category !== "shop" && mapTranslationsToObject(category.translations)

  const {
    productCategories: { nodes: productCategories },
    shopPage: {
      acfShop: { headerH1, headerImage, headerTitle },
    },
  } = data

  let seoData

  if (data.categoryPage) {
    seoData = data.categoryPage.acfSeo
  } else {
    seoData = data.mainPageSEOData.acfSeo
  }

  useEffect(() => {
    dispatch(
      setState({
        products: categoryProducts,
      }),
    )
  }, [])

  const categoryTitle = categoryTranslations?.title ?? category?.title;

  const productsToShow = useSelector(state => state.filterProducts.products)

  return (
    <Layout pageData={pageContext} template={"shop.php"}>
      <SEO
        data={{
          tags: seoData.seoTags,
          title: seoData.seoTitle,
          image: seoData.ogImage,
        }}
      />
      {category.handle && (
        <ShopHeader title={headerTitle} image={headerImage} category={categoryTitle} />
      )}

      {!category.handle && (
        <ShopHeader h1={headerH1} title={headerTitle} image={headerImage} category={categoryTitle} />
      )}

      <div className={s.ProductCategoryHeaderContent}>
        <h2 className={s.ProductCategoryHeader}>
          {shop.allProductsCategoryText}
        </h2>
        <p className={s.ProductCategoryHeader__quantity}>
          {productsToShow.length} {shop.productsFound}
        </p>
      </div>

      <FilterBar
        products={productsToShow}
        productCategories={productCategories}
        currentCategory={categoryTranslations.title}
        unfilteredProducts={categoryProducts}
      />

      {isChristmas && productsToShow.length === 0 && (
        <NoChristmasProductsList />
      )}

      {!(isChristmas && productsToShow.length === 0) && (
        <ProductsList products={productsToShow} />
      )}

      <PaymentBanner />
    </Layout>
  )
}

export default ProductCategory

export const query = graphql`
  query Products($slug: String, $locale: String!) {
    allShopifyCollection(filter: { handle: { eq: $slug } }) {
      nodes {
        title
        handle
        translations(locale: $locale) {
          key
          locale
          value
        }
      }
    }

    shopPage: wpPage(slug: { eq: "shop" }) {
      acfShop {
        headerH1
        headerTitle
        headerImage {
          sourceUrl
        }
      }
    }

    categoryPage: wpPage(slug: { eq: $slug }) {
      acfSeo {
        seoTitle
        seoTags {
          name
          content
        }
        ogImage {
          sourceUrl
        }
      }
    }

    mainPageSEOData: wpPage(slug: { eq: "shop" }) {
      acfSeo {
        seoTitle
        seoTags {
          name
          content
        }
        ogImage {
          sourceUrl
        }
      }
    }

    productCategories: allShopifyCollection {
      nodes {
        title
        handle
        translations(locale: $locale) {
          key
          locale
          value
        }
      }
    }
  }
`
